module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/PasswordRuleTable.ejs -->\n<p>\n    Your password should contain:\n</p>\n<ul class="password-rules">\n    <li id="rule-8-chars">8 characters</li>\n    <li id="rule-1-num">1 number</li>\n</ul>\n<ul class="password-rules">\n    <li id="rule-1-alphabet">1 alphabet</li>\n</ul>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/PasswordRuleTable.ejs
// module id = 552
// module chunks = 1